import { SITE_URL } from "@/config/pages";
import { PHONE_E164 } from "@/config/contact";

// Globaal Plumber-schema — één keer gerenderd in App, geldt voor alle pagina's.
export const PLUMBER_SCHEMA = {
  "@context": "https://schema.org",
  "@type": ["LocalBusiness", "Plumber"],
  "@id": `${SITE_URL}/#organization`,
  name: "Spoedlekkage.nl",
  legalName: "Knap Groep B.V.",
  vatID: "NL870140784B01",
  taxID: "42198096",
  url: SITE_URL,
  telephone: PHONE_E164,
  openingHours: "Mo-Su 00:00-23:59",
  description:
    "Spoedhulp bij lekkages in Noord-Holland, Utrecht en Almere. 24/7 bereikbaar. Bel of app ons, of stuur een foto via WhatsApp.",
  address: {
    "@type": "PostalAddress",
    streetAddress: "Nieuwendammerdijk 526 M 12",
    postalCode: "1023 BX",
    addressLocality: "Amsterdam",
    addressCountry: "NL",
  },
  openingHoursSpecification: {
    "@type": "OpeningHoursSpecification",
    dayOfWeek: ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday", "Sunday"],
    opens: "00:00",
    closes: "23:59",
  },
  areaServed: [
    { "@type": "City", name: "Amsterdam" },
    { "@type": "City", name: "Utrecht" },
    { "@type": "City", name: "Almere" },
    { "@type": "City", name: "Amstelveen" },
    { "@type": "City", name: "Zaandam" },
    { "@type": "City", name: "Amersfoort" },
    { "@type": "City", name: "Hilversum" },
    { "@type": "City", name: "Haarlem" },
  ],
  hasOfferCatalog: {
    "@type": "OfferCatalog",
    name: "Lekkagediensten",
    itemListElement: [
      { "@type": "Offer", itemOffered: { "@type": "Service", name: "Lekdetectie", url: `${SITE_URL}/lekdetectie` } },
      { "@type": "Offer", itemOffered: { "@type": "Service", name: "Daklekkage", url: `${SITE_URL}/daklekkage` } },
      { "@type": "Offer", itemOffered: { "@type": "Service", name: "Leidinglekkage", url: `${SITE_URL}/leidinglekkage` } },
      { "@type": "Offer", itemOffered: { "@type": "Service", name: "Cv-lekkage", url: `${SITE_URL}/cv-lekkage` } },
      { "@type": "Offer", itemOffered: { "@type": "Service", name: "Lekkage badkamer", url: `${SITE_URL}/lekkage-badkamer` } },
      { "@type": "Offer", itemOffered: { "@type": "Service", name: "Waterschade herstel", url: `${SITE_URL}/waterschade` } },
      { "@type": "Offer", itemOffered: { "@type": "Service", name: "Lekkage en verzekering", url: `${SITE_URL}/lekkage-verzekering` } },
      { "@type": "Offer", itemOffered: { "@type": "Service", name: "Lekkage bij VvE's", url: `${SITE_URL}/lekkage-vve` } },
    ],
  },
  parentOrganization: { "@type": "Organization", name: "KNAP Groep" },
  sameAs: [],
  image: `${SITE_URL}/img/foto/hero-team.jpg`,
  logo: `${SITE_URL}/logo-icon-color.png`,
};

export const serviceSchema = ({ serviceType, pageUrl, areaServed }) => ({
  "@context": "https://schema.org",
  "@type": "Service",
  serviceType,
  url: pageUrl,
  provider: { "@id": `${SITE_URL}/#organization` },
  areaServed: areaServed.map((name) => ({ "@type": "City", name })),
});

export const faqSchema = (faqs) => ({
  "@context": "https://schema.org",
  "@type": "FAQPage",
  mainEntity: faqs.map((f) => ({
    "@type": "Question",
    name: f.q,
    acceptedAnswer: { "@type": "Answer", text: f.a },
  })),
});

export const breadcrumbSchema = (items) => ({
  "@context": "https://schema.org",
  "@type": "BreadcrumbList",
  itemListElement: items.map((item, i) => ({
    "@type": "ListItem",
    position: i + 1,
    name: item.label,
    item: `${SITE_URL}${item.to}`,
  })),
});

export const articleSchema = ({ headline, description, datePublished, dateModified, url, authorName }) => ({
  "@context": "https://schema.org",
  "@type": "Article",
  headline,
  description,
  datePublished,
  dateModified,
  author: authorName
    ? { "@type": "Person", name: authorName, worksFor: { "@type": "Organization", name: "Spoedlekkage.nl" } }
    : { "@type": "Organization", name: "Spoedlekkage.nl" },
  publisher: { "@id": `${SITE_URL}/#organization` },
  mainEntityOfPage: url,
});
